/* Fann Bliss — small global extras for the fann layer (loaded after fann-home.js on every page).
   1) Quick add with an optional name: fann-card renders <details data-fh-qn> for name-only designs;
      its "Add to bag" sends properties {Name: …} only when a name was typed.
   2) Countdown: [data-fh-ends="ISO date"] shows data-fh-cd ("Offer ends in [t]") and hides itself
      (or its [data-fh-cd-root] ancestor) once the time has passed.
   3) Cut-outs: product photos shot on white (product cards, the occasion strip, the Countries finder, mug rail,
      bundle builder and idea cards) are turned into transparent cut-outs in the browser, cropped to the
      main piece, and loaded even when native lazy loading never fires (animated rail, hidden tab). */
(function () {
  'use strict';
  if (window.__fhExtras) return; window.__fhExtras = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function FH() { return window.FannHome || {}; }
  var finePointer = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;

  function toast(text, img, opts) { if (FH().toast) FH().toast(text, img, opts); }
  function thumb(url) { return url ? url.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2') : ''; }
  function addItems(items) {
    if (FH().addItems) return FH().addItems(items);
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not add to bag'); return { added: d }; }); });
  }
  function cartUrl() { var c = FH().config; return (c && c.routes && c.routes.cart) || '/cart'; }

  /* ----------------------------------------------------- quick add + name */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-fh-qn-form] [data-fh-add]');
    if (!btn) return;
    /* handled here (capture) so the generic fann-home add doesn't also fire */
    e.preventDefault(); e.stopPropagation();
    if (btn.getAttribute('aria-busy') === 'true') return;
    var id = parseInt(btn.getAttribute('data-fh-add'), 10); if (!id) return;
    var form = btn.closest('[data-fh-qn-form]'), item = { id: id, quantity: 1 }, named = '';
    $$('input[name]', form).forEach(function (inp) {
      var v = String(inp.value || '').replace(/\s+/g, ' ').trim();
      if (v) { item.properties = item.properties || {}; item.properties[inp.name] = v; if (!named) named = v; }
    });
    btn.setAttribute('aria-busy', 'true');
    addItems([item]).then(function (r) {
      var first = r && r.added && (r.added.items ? r.added.items[0] : r.added);
      var label = btn.getAttribute('data-fh-label') || (first && first.product_title) || 'Item';
      toast(label + (named ? ' for “' + named + '”' : '') + ' added', first && first.image ? thumb(first.image) : null, { link: cartUrl(), linkText: 'View bag' });
      $$('input[name]', form).forEach(function (inp) { inp.value = ''; });
      var d = form.closest('details'); if (d) d.open = false;
      btn.removeAttribute('aria-busy');
    }).catch(function (err) {
      toast((err && err.message) || 'Could not add to bag', null, { error: true });
      btn.removeAttribute('aria-busy');
    });
  }, true);

  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || !d.matches || !d.matches('details[data-fh-qn]')) return;
    var card = d.closest('.fh-pcard');
    if (card) card.classList.toggle('fh-qn-on', d.open);
    if (d.open) {
      $$('details[data-fh-qn][open]').forEach(function (o) { if (o !== d) o.open = false; });
      var inp = $('input[name]', d);
      if (inp && finePointer) setTimeout(function () { try { inp.focus({ preventScroll: true }); } catch (_) { inp.focus(); } }, 30);
    }
  }, true);
  document.addEventListener('click', function (e) {
    var x = e.target.closest && e.target.closest('[data-fh-qn-close]');
    if (x) { e.preventDefault(); var dx = x.closest('details'); if (dx) { dx.open = false; var sm = $('summary', dx); if (sm) sm.focus(); } return; }
    $$('details[data-fh-qn][open]').forEach(function (o) { if (!o.contains(e.target)) o.open = false; });
  });
  document.addEventListener('keydown', function (e) {
    var inQn = e.target && e.target.closest && e.target.closest('[data-fh-qn-form]');
    if (inQn && e.key === 'Enter' && e.target.tagName === 'INPUT') { e.preventDefault(); var go = $('[data-fh-add]', inQn); if (go) go.click(); return; }
    if (e.key === 'Escape') { var open = e.target.closest && e.target.closest('details[data-fh-qn][open]'); if (open) { open.open = false; var s2 = $('summary', open); if (s2) s2.focus(); } }
  });

  /* ------------------------------------------------------------ countdown */
  function initCountdown(scope) {
    $$('[data-fh-ends]', scope || document).forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-fh-ends'));
      if (isNaN(end)) return;
      var out = $('[data-fh-cd-t]', el) || el;
      var tpl = el.getAttribute('data-fh-cd') || 'Ends in [t]';
      function tick() {
        var ms = end - Date.now();
        if (ms <= 0) { var root = el.closest('[data-fh-cd-root]') || el; root.hidden = true; return false; }
        var d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5), m = Math.max(1, Math.floor(ms / 6e4));
        var t = d >= 1 ? d + (d === 1 ? ' day' : ' days') : h >= 1 ? h + (h === 1 ? ' hour' : ' hours') : m + (m === 1 ? ' minute' : ' minutes');
        out.textContent = tpl.replace('[t]', t);
        el.hidden = false;
        return true;
      }
      if (el.__fhCd) clearInterval(el.__fhCd);
      if (tick()) el.__fhCd = setInterval(function () { if (!tick()) clearInterval(el.__fhCd); }, 60000);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initCountdown(); }); else initCountdown();
  document.addEventListener('shopify:section:load', function (e) { if (e.target) initCountdown(e.target); });

  /* ------------------------------------------------------------- cut-outs */
  /* square erode (grow=false) or dilate (grow=true) of a 0/1 mask, radius r, as two separable window passes */
  function morph(src, w, h, r, grow) {
    var tmp = new Uint8Array(w * h), out = new Uint8Array(w * h), pre = new Int32Array(Math.max(w, h) + 1), full = 2 * r + 1, x, y, a, b, cnt;
    for (y = 0; y < h; y++) {
      for (x = 0; x < w; x++) pre[x + 1] = pre[x] + src[y * w + x];
      for (x = 0; x < w; x++) { a = x - r < 0 ? 0 : x - r; b = x + r > w - 1 ? w - 1 : x + r; cnt = pre[b + 1] - pre[a]; tmp[y * w + x] = grow ? (cnt > 0 ? 1 : 0) : (cnt === full ? 1 : 0); }
    }
    for (x = 0; x < w; x++) {
      for (y = 0; y < h; y++) pre[y + 1] = pre[y] + tmp[y * w + x];
      for (y = 0; y < h; y++) { a = y - r < 0 ? 0 : y - r; b = y + r > h - 1 ? h - 1 : y + r; cnt = pre[b + 1] - pre[a]; out[y * w + x] = grow ? (cnt > 0 ? 1 : 0) : (cnt === full ? 1 : 0); }
    }
    return out;
  }
  /* White ground → alpha: flood the near-white ground in from the edges, keep the grey floor shadow as a soft
     dark shadow, clear pure-white holes (inside a mug handle), fade and de-fringe light edge pixels, then crop to
     the largest piece (a "3 mugs" composite keeps only the big mug). Returns a canvas, or null. */
  function cutout(img, solid) {
    var W = img.naturalWidth, H = img.naturalHeight;
    if (!W || !H) return null;
    var sc = Math.min(1, 520 / Math.max(W, H)), w = Math.max(1, Math.round(W * sc)), h = Math.max(1, Math.round(H * sc)), n = w * h;
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(img, 0, 0, w, h);
    var d = x.getImageData(0, 0, w, h), p = d.data;
    var bg = new Uint8Array(n), q = new Int32Array(n), qh = 0, qt = 0, i, k, o;
    if (p[3] < 16 && p[(w - 1) * 4 + 3] < 16 && p[(n - w) * 4 + 3] < 16 && p[(n - 1) * 4 + 3] < 16) {
      /* already a transparent cut-out: just trim the empty margin */
      var tx0 = w, tx1 = -1, ty0 = h, ty1 = -1;
      for (k = 0; k < n; k++) if (p[k * 4 + 3] > 8) { var tx = k % w, ty = (k / w) | 0; if (tx < tx0) tx0 = tx; if (tx > tx1) tx1 = tx; if (ty < ty0) ty0 = ty; if (ty > ty1) ty1 = ty; }
      if (tx1 < 0) return null;
      var tc = document.createElement('canvas'); tc.width = tx1 - tx0 + 1; tc.height = ty1 - ty0 + 1;
      tc.getContext('2d').drawImage(c, tx0, ty0, tc.width, tc.height, 0, 0, tc.width, tc.height);
      return tc;
    }
    function mn(j) { o = j * 4; var r = p[o], g = p[o + 1], b = p[o + 2]; return r < g ? (r < b ? r : b) : (g < b ? g : b); }
    function sat(j) { o = j * 4; var r = p[o], g = p[o + 1], b = p[o + 2]; return (r > g ? (r > b ? r : b) : (g > b ? g : b)) - (r < g ? (r < b ? r : b) : (g < b ? g : b)); }
    function flood(test, mark, noUp) {
      while (qh < qt) { i = q[qh++]; var cx = i % w;
        if (cx > 0 && !bg[i - 1] && test(i - 1)) { bg[i - 1] = mark; q[qt++] = i - 1; }
        if (cx < w - 1 && !bg[i + 1] && test(i + 1)) { bg[i + 1] = mark; q[qt++] = i + 1; }
        if (!noUp && i >= w && !bg[i - w] && test(i - w)) { bg[i - w] = mark; q[qt++] = i - w; }
        if (i < n - w && !bg[i + w] && test(i + w)) { bg[i + w] = mark; q[qt++] = i + w; } }
    }
    var ground = function (j) { return mn(j) >= 246 && sat(j) <= 12; };
    function seed(j) { if (!bg[j] && ground(j)) { bg[j] = 1; q[qt++] = j; } }
    for (k = 0; k < w; k++) { seed(k); seed((h - 1) * w + k); }
    for (k = 0; k < h; k++) { seed(k * w); seed(k * w + w - 1); }
    if (qt < (w + h)) return null; /* not a white-ground photo: leave it alone */
    flood(ground, 1);
    var top = h, bot = 0;
    for (k = 0; k < n; k++) if (!bg[k]) { var yy = (k / w) | 0; if (yy < top) top = yy; if (yy > bot) bot = yy; }
    if (bot <= top) return null;
    var band = top + (bot - top) * 0.78;
    qh = 0; qt = 0;
    for (k = 0; k < n; k++) if (bg[k] === 1 && ((k / w) | 0) >= band) q[qt++] = k;
    flood(function (j) { return ((j / w) | 0) >= band && mn(j) >= 150 && sat(j) <= 6; }, 2, true);
    /* the mug body is the widest run of columns that span nearly the full height; a handle hole sits outside it, so
       white print on the body is never punched out */
    var seen = new Uint8Array(n), minHole = Math.max(30, n * 0.0006), colc = new Int32Array(w), cmax = 0, b0 = 0, b1 = -1, run0 = -1;
    if (!solid) {
      var ctop = new Int32Array(w).fill(h), cbot = new Int32Array(w).fill(-1);
      for (k = 0; k < n; k++) if (!bg[k]) { var cxk = k % w, cyk = (k / w) | 0; if (cyk < ctop[cxk]) ctop[cxk] = cyk; if (cyk > cbot[cxk]) cbot[cxk] = cyk; }
      for (k = 0; k < w; k++) { colc[k] = cbot[k] >= ctop[k] ? cbot[k] - ctop[k] + 1 : 0; if (colc[k] > cmax) cmax = colc[k]; }
      for (k = 0; k <= w; k++) {
        if (k < w && colc[k] >= cmax * 0.8) { if (run0 < 0) run0 = k; }
        else if (run0 >= 0) { if (k - 1 - run0 > b1 - b0) { b0 = run0; b1 = k - 1; } run0 = -1; }
      }
    }
    for (k = 0; k < n; k++) {
      if (solid) break; /* tumblers and bottles have no handle: their white print areas stay */
      if (bg[k] || seen[k] || mn(k) < 253) continue;
      var region = [k], s = 0; seen[k] = 1;
      while (s < region.length) { i = region[s++]; var cx3 = i % w, nb = [cx3 > 0 ? i - 1 : -1, cx3 < w - 1 ? i + 1 : -1, i >= w ? i - w : -1, i < n - w ? i + w : -1];
        for (var t = 0; t < 4; t++) { var j = nb[t]; if (j >= 0 && !seen[j] && !bg[j] && mn(j) >= 253) { seen[j] = 1; region.push(j); } } }
      if (region.length < minHole || region.length > n * 0.03) continue;
      var outside = 0;
      for (var r3 = 0; r3 < region.length; r3++) { var cr = region[r3] % w; if (cr < b0 + 2 || cr > b1 - 2) outside++; }
      if (outside >= region.length * 0.9) for (var r2 = 0; r2 < region.length; r2++) bg[region[r2]] = 1;
    }
    for (k = 0; k < n; k++) {
      o = k * 4;
      if (bg[k] === 1) { p[o + 3] = 0; continue; }
      if (bg[k] === 2) { var L = mn(k); o = k * 4; p[o] = 22; p[o + 1] = 24; p[o + 2] = 40; p[o + 3] = Math.round(255 * Math.min(0.4, (255 - L) / 255 * 1.5)); continue; }
      var cx2 = k % w;
      if (!((cx2 > 0 && bg[k - 1] === 1) || (cx2 < w - 1 && bg[k + 1] === 1) || (k >= w && bg[k - w] === 1) || (k < n - w && bg[k + w] === 1))) continue;
      var R = p[o], G = p[o + 1], B = p[o + 2], m = Math.min(R, G, B);
      if (m > 200) {
        var a = 1 - (m - 200) / 55;
        if (a < 0.08) { p[o + 3] = 0; continue; }
        p[o] = Math.max(0, Math.min(255, (R - 255 * (1 - a)) / a)); p[o + 1] = Math.max(0, Math.min(255, (G - 255 * (1 - a)) / a)); p[o + 2] = Math.max(0, Math.min(255, (B - 255 * (1 - a)) / a));
        p[o + 3] = Math.round(255 * a);
      }
    }
    /* mugs: a composite photo's small side mugs often touch the big mug's handle - shave 3px off every piece,
       keep the biggest one, grow it back and drop everything it doesn't cover (floor shadow stays) */
    if (!solid) {
      var S = new Uint8Array(n);
      for (k = 0; k < n; k++) S[k] = p[k * 4 + 3] >= 200 ? 1 : 0;
      var Er = morph(S, w, h, 3, false), lab0 = new Int32Array(n), big = 0, bigN = 0, id0 = 0;
      for (k = 0; k < n; k++) {
        if (!Er[k] || lab0[k]) continue;
        id0++; qh = 0; qt = 0; q[qt++] = k; lab0[k] = id0; var c0 = 0;
        while (qh < qt) { i = q[qh++]; c0++; var ex0 = i % w;
          if (ex0 > 0 && Er[i - 1] && !lab0[i - 1]) { lab0[i - 1] = id0; q[qt++] = i - 1; }
          if (ex0 < w - 1 && Er[i + 1] && !lab0[i + 1]) { lab0[i + 1] = id0; q[qt++] = i + 1; }
          if (i >= w && Er[i - w] && !lab0[i - w]) { lab0[i - w] = id0; q[qt++] = i - w; }
          if (i < n - w && Er[i + w] && !lab0[i + w]) { lab0[i + w] = id0; q[qt++] = i + w; } }
        if (c0 > bigN) { bigN = c0; big = id0; }
      }
      if (big) {
        for (k = 0; k < n; k++) S[k] = lab0[k] === big ? 1 : 0;
        var Dl = morph(S, w, h, 6, true);
        for (k = 0; k < n; k++) if (!Dl[k] && bg[k] !== 2) p[k * 4 + 3] = 0;
      }
    }
    /* keep the largest solid piece */
    var lab = new Int32Array(n), best = 0, bestN = 0, bb = null, id = 0;
    for (k = 0; k < n; k++) {
      if (lab[k] || p[k * 4 + 3] < 200) continue;
      id++; qh = 0; qt = 0; q[qt++] = k; lab[k] = id;
      var cnt = 0, x0 = w, x1 = 0, y0 = h, y1 = 0;
      while (qh < qt) { i = q[qh++]; cnt++; var ix = i % w, iy = (i / w) | 0;
        if (ix < x0) x0 = ix; if (ix > x1) x1 = ix; if (iy < y0) y0 = iy; if (iy > y1) y1 = iy;
        var nn = [ix > 0 ? i - 1 : -1, ix < w - 1 ? i + 1 : -1, i >= w ? i - w : -1, i < n - w ? i + w : -1];
        for (var u = 0; u < 4; u++) { var z = nn[u]; if (z >= 0 && !lab[z] && p[z * 4 + 3] >= 200) { lab[z] = id; q[qt++] = z; } } }
      if (cnt > bestN) { bestN = cnt; best = id; bb = [x0, x1, y0, y1]; }
    }
    if (!bb || bestN < n * 0.01) return null;
    var pad = Math.round((bb[1] - bb[0]) * 0.03), sx = Math.max(0, bb[0] - pad), ex = Math.min(w - 1, bb[1] + pad), sy = Math.max(0, bb[2] - pad), ey = bb[3];
    var ex2 = Math.min(h - 1, bb[3] + Math.round((bb[3] - bb[2]) * 0.1));
    for (var yy2 = bb[3] + 1; yy2 <= ex2; yy2++) { var any = false; for (var xx = sx; xx <= ex; xx++) if (p[(yy2 * w + xx) * 4 + 3] > 8) { any = true; break; } if (!any) break; ey = yy2; }
    /* clear other pieces that fall inside the crop */
    for (var yy3 = sy; yy3 <= ey; yy3++) for (var xx3 = sx; xx3 <= ex; xx3++) { var kk = yy3 * w + xx3; if (lab[kk] && lab[kk] !== best) p[kk * 4 + 3] = 0; }
    x.putImageData(d, 0, 0);
    var out = document.createElement('canvas'); out.width = ex - sx + 1; out.height = ey - sy + 1;
    out.getContext('2d').drawImage(c, sx, sy, out.width, out.height, 0, 0, out.width, out.height);
    return out;
  }
  var cutCache = {};
  function sameOrigin(u) { try { return new URL(u, location.href).origin === location.origin; } catch (e) { return false; } }
  function loadFresh(url) {
    return new Promise(function (res) {
      var im = new Image(), own = sameOrigin(url);
      /* another host (preview domain, cdn.shopify.com): ask for CORS, and skip any cached copy fetched without it */
      if (!own) { im.crossOrigin = 'anonymous'; url += (url.indexOf('?') > -1 ? '&' : '?') + 'fhcut=1'; }
      im.decoding = 'async'; im.onload = function () { res(im); }; im.onerror = function () { res(null); }; im.src = url;
    });
  }
  /* cut-outs run one after another in idle time, never several in one frame; the newest request goes first, so the
     photos just scrolled to (or a tab just opened) don't wait behind the rest of the page */
  var jobs = [], pumping = false;
  function pump() {
    (window.requestIdleCallback || function (f) { return setTimeout(function () { f({ timeRemaining: function () { return 10; } }); }, 16); })(function (dl) {
      do { var f = jobs.shift(); if (f) f(); } while (jobs.length && dl.timeRemaining() > 14);
      if (jobs.length) pump(); else pumping = false;
    }, { timeout: 600 });
  }
  function idle(fn) { jobs.unshift(fn); if (!pumping) { pumping = true; pump(); } }
  function copyOf(im) {
    var sc = Math.min(1, 520 / Math.max(im.naturalWidth, im.naturalHeight)), c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(im.naturalWidth * sc)); c.height = Math.max(1, Math.round(im.naturalHeight * sc));
    c.getContext('2d').drawImage(im, 0, 0, c.width, c.height); return c;
  }
  function makeCut(url, fromImg, plain, solid) {
    var key = url + (plain ? '#plain' : solid ? '#solid' : '');
    if (cutCache[key]) return cutCache[key];
    cutCache[key] = new Promise(function (res) {
      var ready = fromImg && fromImg.complete && fromImg.naturalWidth > 2 ? Promise.resolve(fromImg) : loadFresh(url);
      ready.then(function (im) {
        if (!im) return res(null);
        idle(function () {
          var cv = null; try { cv = plain ? copyOf(im) : cutout(im, solid); } catch (e) { cv = null; }
          if (!cv) return res(null);
          try { cv.toBlob(function (bl) { res(bl ? URL.createObjectURL(bl) : null); }, 'image/png'); } catch (e) { res(null); }
        });
      });
    });
    return cutCache[key];
  }
  function reveal(span) {
    if (span.__fhCut) return; span.__fhCut = 1;
    var url = span.getAttribute('data-fh-src'), img = $('img', span);
    if (!url || !img) return;
    var plain = span.classList.contains('fh-cutout'), done = false;
    /* only mugs get their handle hole cleared; tumblers and bottles keep every white part of their print */
    var card = span.closest('.fh-pcard'), mug = /mug/i.test(url) || span.classList.contains('fh-crop-mug') || !!(card && /\bmug\b/i.test(card.textContent));
    /* eager: a lazy photo inside a moving rail or a tab that opens later may otherwise never load */
    function use(blobUrl) { img.loading = 'eager'; img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = blobUrl; }
    function raw() { img.loading = 'eager'; if (img.getAttribute('src') !== url && !img.getAttribute('srcset')) img.src = url; span.classList.add('fh-cut-raw'); }
    var fallback = setTimeout(function () { if (done) return; done = true; raw(); }, 6000);
    makeCut(url, sameOrigin(url) && img.getAttribute('src') === url ? img : null, plain, !mug).then(function (blobUrl) {
      if (done) { if (blobUrl) { use(blobUrl); span.classList.remove('fh-cut-raw'); span.classList.add('fh-cut-ok'); } return; }
      done = true; clearTimeout(fallback);
      if (blobUrl) { use(blobUrl); span.classList.add('fh-cut-ok'); }
      else raw();
    });
  }
  var cutIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      cutIO.unobserve(e.target);
      if (e.target.matches('[data-fh-src]')) reveal(e.target);
      else { e.target.__fhCutRevealed = 1; $$('[data-fh-src]', e.target).forEach(reveal); } /* a moving rail: take every tile at once */
    });
  }, { rootMargin: '700px 900px' }) : null;
  /* Where a photo's own address is missing (some embedded browsers blank the src of script-built images),
     read it back from the Countries feed the page already carries. */
  var cdata = null;
  function countriesData() {
    if (cdata) return cdata;
    var map = {};
    $$('script[data-fh-countries]').forEach(function (sc) {
      try {
        var dd = JSON.parse(sc.textContent || '{}'), base = dd.base || '';
        (dd.products || []).forEach(function (pr) {
          if (!pr.n || !pr.i) return;
          var cc = map[pr.n] = map[pr.n] || {}, tt = pr.t === 'tumbler' ? 'tumbler' : 'mug';
          if (!cc[tt]) cc[tt] = pr.k === 1 ? pr.i : base + pr.i;
        });
      } catch (e) {}
    });
    return (cdata = map);
  }
  function withWidth(u, wd) { return u.replace(/(\?|&)width=\d+/, '') + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + wd; }
  function resolveSpan(sp) {
    var im = $('img', sp); if (!im) return null;
    var src = im.getAttribute('src') || '';
    if (/^(https?:)?\/\//.test(src)) return src;
    if (/^https?:/.test(im.currentSrc || '')) return im.currentSrc;
    var set = (im.getAttribute('srcset') || '').split(',').map(function (c) { return c.trim().split(/\s+/); }).filter(function (c) { return /^(https?:)?\/\//.test(c[0]); });
    if (set.length) { var pick = set[0][0]; set.forEach(function (c) { if ((parseInt(c[1], 10) || 0) <= 640) pick = c[0]; }); return pick; }
    if (/^data:image\/svg/.test(src)) return null; /* the drawn "no photo yet" mug */
    var country = '', type = 'mug', wd = 360, el, tum = sp.classList.contains('fh-crop-tum') || sp.classList.contains('fh-tall');
    if ((el = sp.closest('.fh-m'))) { var lb = el.querySelector('span:last-child'); country = lb ? lb.textContent : ''; type = tum ? 'tumbler' : 'mug'; wd = 300; }
    else if ((el = sp.closest('[data-fh-pimg]'))) {
      var fin = sp.closest('[data-fh-finder]'), pn = fin && $('[data-fh-pname]', fin), pt = fin && $('[data-ptype][aria-pressed="true"]', fin);
      type = pt && pt.getAttribute('data-ptype') === 'tumbler' ? 'tumbler' : 'mug';
      country = pn ? pn.textContent.replace(/ (Mug · 320ml|480ml Tumbler)$/, '') : ''; wd = 480;
    }
    else if ((el = sp.closest('.fh-bi'))) { var l2 = $('.fh-lbl', el); country = l2 ? l2.textContent : ''; type = tum || parseFloat(el.style.height) > 35 ? 'tumbler' : 'mug'; }
    else if ((el = sp.closest('.fh-ba'))) {
      var card = el.closest('[data-fh-idea]');
      try { var its = JSON.parse(card.getAttribute('data-fh-idea')).items || [], x = its[$$('.fh-ba', card).indexOf(el)]; if (x) { country = x.c; type = x.t === 'tumbler' ? 'tumbler' : 'mug'; } } catch (e) {}
      wd = 240;
    }
    var cc = countriesData()[String(country).trim()], u = cc && cc[type];
    return u ? withWidth(u, wd) : null;
  }
  var CUT_SEL = '[data-fh-src], .fh-photo:not(.fh-cutout), .fh-mugrail .fh-photo, [data-fh-pimg] .fh-photo, .fh-bshelf .fh-bi .fh-photo, .fh-bart .fh-ba .fh-photo, .fh-os-img';
  function watchCuts(scope) {
    $$(CUT_SEL, scope || document).forEach(function (sp) {
      if (sp.__fhCut || sp.__fhCutSeen) return;
      if (!sp.hasAttribute('data-fh-src')) {
        var u = resolveSpan(sp); if (!u) { sp.__fhCutSeen = 1; sp.classList.add('fh-cut-raw'); return; } /* nothing to cut (drawn placeholder): show it */
        sp.setAttribute('data-fh-src', u);
        if (/landmark/i.test(u) && !sp.classList.contains('fh-cutout')) sp.classList.add('fh-land');
      }
      sp.__fhCutSeen = 1;
      var rail = sp.closest('.fh-mugrail');
      if (!cutIO) reveal(sp);
      else if (rail) { if (!rail.__fhCutSeen) { rail.__fhCutSeen = 1; cutIO.observe(rail); } else if (rail.__fhCutRevealed) reveal(sp); }
      else cutIO.observe(sp);
    });
  }
  document.documentElement.classList.add('fh-cut-on');
  function startCuts() {
    watchCuts();
    var queued = false;
    if ('MutationObserver' in window) new MutationObserver(function (ms) {
      if (queued) return;
      for (var a = 0; a < ms.length; a++) if (ms[a].addedNodes.length) { queued = true; setTimeout(function () { queued = false; watchCuts(); }, 30); return; }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startCuts); else startCuts();
  /* photos in tab panels that start hidden (the homepage campaign tabs: Countries, World Cup…) are cut out once the
     page has settled, so a tab opens with its photos ready instead of empty boxes */
  function preCutHidden() { $$('[role="tabpanel"][hidden] [data-fh-src]').forEach(reveal); }
  function afterLoad() { setTimeout(preCutHidden, 1500); }
  if (document.readyState === 'complete') afterLoad(); else window.addEventListener('load', afterLoad);
})();